export const PERFORMANCE_METRICS_CHANNEL = 'affine-performance-metrics';

export type WorkerPerformanceMessage =
  | {
      kind: 'worker-fetch';
      url: string;
      method: string;
      startTime: number;
      duration: number;
      status?: number;
      size?: number;
    }
  | {
      kind: 'worker-websocket';
      url: string;
      startTime: number;
      event: 'open' | 'first-message' | 'close';
      duration: number;
    };
